import React, { useEffect, useState } from "react";
import FooterStyle from "./FooterStyle";
import { useRouter } from "next/router";
import { LinkAnchor, refferalRouting } from "@Components/Common/CommonMethods";
import DialogComponent from "@Components/Common/DialogComponent";
import ContactUsPopup from "@Components/ContactUsPopup";
const Footer = ({ showloader, isLoginToken, innerLoader, subDomain, setOpenForm, openForm, profileData, ...props }) => {
  const router = useRouter();
  const store = router?.query?.page ? router?.query?.page : "us";

  const [openContactForm, setOpenContactForm] = useState(false)

  const Validatelogin = (e) => {
    router.push(`/us/signup/?d=is_affiliate`);
  };

  const DATA = profileData?.user_data?.userdetails?.[0]?.test_report_release;
  const pdfUrl = {
    discloser:
      "https://admin.snipnutrition.com/media/documents/SNiP%20Income%20Disclosure%20Statement.pdf",
    termsCondition:
      "https://admin.snipnutrition.com/media/documents/snip_nutrigenomics_terms_and_conditions_clean_copy_v5.5.1.24.pdf",
    website_privacy_policy:
      "https://admin.snipnutrition.com/media/documents/Website%20privacy%20policy.pdf",
    refund_return_policy:
      "https://admin.snipnutrition.com/media/documents/snip_nutrigenomics_return_refund_policy.pdf"
  };

  useEffect(() => {
    document.body.classList.add("molecule-footer");
  }, []);
  useEffect(() => {
    if (innerLoader === true) {
      document.body.classList.add("bg-footer");
    } else {
      document.body.classList.remove("bg-footer");

    }
    if (router?.asPath === "/us/signup/?d=is_affiliate&r=packs") {
      props?.setActiveStep(1);
    }
  }, [router]);


  const SocialIconsData = [
    {
      icon: "/images/linkedIn.png",
      link: "https://www.linkedin.com/company/snipnutrigenomics/",
    },
    {
      icon: "/images/Facebook.png",
      link: "https://www.facebook.com/snipnutrition",
    },
    {
      icon: "/images/instagram.png",
      link: "https://www.instagram.com/snipnutrition",
    },
    {
      icon: "/images/Youtube.png",
      link: "https://youtube.com/@snipnutrition",
    }
  ]

  function handleNewsletter() {
    document.body.classList.add("professional_retailer_form_popup");
    setOpenForm(true);
  }

  const referral_name = localStorage.getItem("publicName") ? localStorage.getItem("publicName") : "";

  return (
    <>
      <FooterStyle>
        <div className="fotter_section">
          <div className="container_footer">
            <div className="footer_first_section">
              <div className="container">
                <div className="row">
                  <div className="col-md">
                    <div className="footer_section">
                      <img src="/images/logo_snip.png" loading="lazy" alt="snip-logo" />
                      <p>
                        SNiP Nutrigenomics, Inc. 901 Sam Rayburn Hwy. Melissa,
                        TX 75454
                      </p>
                      <div className="socialIcons">
                        {SocialIconsData?.map((link, index) => (
                          <LinkAnchor
                            key={index}
                            href={link?.link}
                            target="_blank"
                            aria-label="social"
                          >
                            <img src={link?.icon} loading="lazy" alt="social-icons" />
                          </LinkAnchor>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md left-border">
                    <div className="first_footer_option">
                      <div className="d-flex">
                        <LinkAnchor
                          className="footer_link"
                          href="mailto:support@snipnutrition.com"
                        >
                          Support
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/faq")}
                        >
                          FAQs
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/privacy-policy")}
                        >
                          Your DNA Privacy
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={pdfUrl?.refund_return_policy} target="_blank"
                        >
                          Refund and Return Policy
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={pdfUrl?.website_privacy_policy}
                          target="_blank">
                          Website Privacy Policy
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={pdfUrl?.discloser}
                          target="_blank"
                        >
                          Income Disclosure
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={pdfUrl?.termsCondition}
                          target="_blank"
                        >
                          Terms and Conditions
                        </LinkAnchor>
                      </div>
                    </div>
                  </div>
                  <div className="col-md left-border">
                    <div className="second_footer_option">
                      <div className="d-flex">
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/wellness_professionals")}
                        >
                          Wellness Professionals
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/employers")}
                        >
                          Employers
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/retailers")}
                        >
                          Retailers
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/affliateshare")}
                        >
                          Affiliates
                        </LinkAnchor>
                        <LinkAnchor
                          className="footer_link"
                          href={refferalRouting("/us/about_us")}
                        >
                          About Us
                        </LinkAnchor>
                        {/* <LinkAnchor className="footer_link" href="mailto:support@snipnutrition.com">Contact Us</LinkAnchor> */}
                        <a className="footer_link" onClick={() => setOpenContactForm(true)}>Contact Us</a>

                        {!DATA &&
                          <LinkAnchor className="footer_link" href={refferalRouting("/dna-data-entry")}>DNA Data Entry</LinkAnchor>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="col-md left-border">
                    <div className="d-flex">
                      <LinkAnchor
                        className="footer_link"
                        href={refferalRouting("/us/login")}
                      >
                        Login
                      </LinkAnchor>
                      {/* <LinkAnchor className="footer_link" href="/">Register my Kit</LinkAnchor> */}
                      <a className="footer_link" href="https://blog.snipnutrition.com/" target="_blank">Blog</a>
                      <LinkAnchor
                        className="footer_link"
                        href={refferalRouting("/samplecodereport")}
                      >
                        Sample DNA Report
                      </LinkAnchor>
                      <LinkAnchor
                        className="footer_link"
                        href={refferalRouting('/us/newsletter/')}>
                        Newsletter Sign Up
                      </LinkAnchor>
                      <LinkAnchor
                        className="footer_link"
                        href="mailto:info@snipnutrition.com?subject=SNiP Media Inquiry"
                      >
                        Media Inquiries
                      </LinkAnchor>
                      <LinkAnchor className="footer_link" href={refferalRouting('/international_orders/')}>International Orders</LinkAnchor>
                      <LinkAnchor
                        className="footer_link"
                        href={refferalRouting("/reviews")}
                      >
                        Leave us a Review
                      </LinkAnchor>
                      <p className="referrer-color-cstm" style={{ color: "transparent" }}>Referrer: {referral_name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="copyright_issue">
              <p>
                SNIP Nutrigenomics &#169; {new Date().getFullYear()}. All rights
                reserved.
              </p>
              {/* <div className='small_text'> */}
              <p>
                These statements have not been evaluated by the Food and Drug
                Administration. These products are not intended to diagnose,
                treat, cure, or prevent any disease.
              </p>
              {/* </div> */}
            </div>
          </div>
        </div>


        {showloader === true && (
          <div className="loader-back">
            <div className="Loader loader-main" data-text="Loading..."></div>
          </div>
        )}
        {innerLoader === true && (
          <div className="flexbox">
            <div className="">
              <div className="bt-spinner"></div>
            </div>
          </div>
        )}
      </FooterStyle>

      <DialogComponent opend={openContactForm} handleClose={() => setOpenContactForm(false)} classFor="oneTime-Order">
        <ContactUsPopup openContactForm={openContactForm} setOpenContactForm={setOpenContactForm} setInnerLoader={props.setInnerLoader} />
      </DialogComponent>
    </>
  );
};
export default Footer;
